<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="supplierReturnOrders.data"
      style="width: 100%"
      row-key="id"
      highlight-current-row
      :row-class-name="'pointer-row'"
      @sort-change="handleSortChange"
      @row-click="(row) => $router.replace('/processes/supplier-return-orders/view/' + row.id)"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="70"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="supplierReturnOrder"
            :options="['settings', 'export']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :supplier-return-order="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="supplierReturnOrders.per_page"
        layout="total, prev, pager, next"
        :total="supplierReturnOrders.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import Actions from './Actions';
import TableSettings from '../../TableSettings';
import columns, { allColumns, labels, compareTypes } from './columns';

export default {
  components: {
    Actions,
    TableSettings,
    ...columns,
  },
  data() {
    return {
      labels,
      allColumns,
      tableKey: 0,
      currentPage: 1,
      currentSort: {
        prop: 'created_at',
        order: 'asc',
      },
    };
  },
  computed: {
    supplierReturnOrders() {
      return this.$store.getters['supplierReturnOrder/supplierReturnOrders'];
    },
    tableConfig() {
      return JSON.parse(JSON.stringify(this.$store.getters['supplierReturnOrder/tableConfig']));
    },
    loading() {
      return this.$store.getters['supplierReturnOrder/loading'];
    },
  },
  watch: {
    tableConfig() {
      this.tableKey++;
    },
  },
  async mounted() {
    this.$store.commit('supplierReturnOrder/setFilterString', '');
    this.$store.commit('supplierReturnOrder/setCurrentPage', this.currentPage);
    this.$store.commit('supplierReturnOrder/setSorting', this.currentSort);
    await this.$store.dispatch('supplierReturnOrder/fetchAll');
  },
  methods: {
    handleCurrentChange(val) {
      this.$store.commit('supplierReturnOrder/setCurrentPage', val);
      this.$store.dispatch('supplierReturnOrder/fetchAll');
    },
    handleSortChange({ column, prop, order }) {
      if (column.sortable === 'custom') {
        this.$store.commit('supplierReturnOrder/setSorting', { prop, order, compareType: compareTypes[prop] || 'string' });
        this.$store.dispatch('supplierReturnOrder/fetchAll');
      }
    },
  },
};
</script>
<style>
  .pointer-row {
    cursor: pointer;
  }
</style>
